export default "__VITE_ASSET__CBRopyoZ__"